/*
 * @Author: soji
 * @Description: 描述
 * @Date: 2024-07-09 16:24:57
 */

/*
 * @Author: soji
 * @Description: 餐品工具类
 * @Date: 2021-04-14 17:24:03
 */

import COM from './common.js';
import amendHelp from './amendHelp.js';

const computePrice = (price)=> COM.computePrice(price,2);


let amendProductFee = {

  countGiveProductsFee(giveProducts) {
    let fee = 0;
    (giveProducts || []).map(pro => {
      fee += pro.totalPrice;
    })
    return computePrice(fee);
  },

  // 给购物车products增加originInfo的字段 item.originInfo = `原订单数量${item.num} 单价${item.originOrderPricing || item.price}`
  firstInitOriginOrderInfo(products, cartProductsObj) {
    const countRequirementItemPrice = function(matchReqItem) {
      let price = 0;
      (matchReqItem.propertys || []).map(per => {
         (per.items || []).map(item => {
          price += item.price * (typeof item.num === 'undefined' ? 1 : item.num );
         })
      })
      return computePrice(price)
    };

    (products || []).map(pro => {
      let singlePrice = 0;
      let matchProObj = cartProductsObj[pro._key];
      if(matchProObj) {
        // 外壳单价
        singlePrice += matchProObj.price;
        pro.originInfo = `原订单数量${pro.num} 单价${singlePrice}`
        matchProObj.originInfo = `原订单数量${pro.num} 单价${singlePrice}`
        // 特殊要求单价
        if(matchProObj.listRequirements && matchProObj.isRequirement && pro.isRequirement && matchProObj._additional) {
          let matchReqItem = matchProObj.listRequirements.find(reqItem => reqItem.index === pro._index);
          let matchAdditionalListItem = matchProObj._additional.list.find(reqItem => reqItem._index === pro._index);
          if(matchReqItem && matchAdditionalListItem) {
            singlePrice += countRequirementItemPrice(matchReqItem)
            pro.originInfo = `原订单数量${pro.num} 单价${singlePrice}`
            matchAdditionalListItem.originInfo = `原订单数量${pro.num} 单价${singlePrice}`
          }
        }
        // 套餐单价
        if(matchProObj.groups && pro.products && matchProObj._combo) {
          let matchGroupItem = matchProObj.groups.find(reqItem => reqItem.index === pro._index);
          let matchComboListItem = matchProObj._combo.list.find(comboListItem => comboListItem._index == pro._index)
          if(matchGroupItem && matchComboListItem) {
            singlePrice += (amendHelp.countComboItemSinglePriceFromOrder(matchGroupItem, matchProObj, 'price') - matchProObj.price) // 避免重复加外壳费用
            pro.originInfo = `原订单数量${pro.num} 单价${singlePrice}`
            matchComboListItem.originInfo = `原订单数量${pro.num} 单价${singlePrice}`
          }
        }
      }
    });

  },
  afterInitOriginOrderInfo(products, cartProductsObj) {
    (products || []).map(pro => {
      let matchProObj = cartProductsObj[pro._key];
      if(matchProObj) {
        // 外壳单价
        pro.originInfo = matchProObj.originInfo
        // 特殊要求单价
        if(matchProObj._additional && matchProObj._additional.list && matchProObj.isRequirement && pro.isRequirement) {
          let matchAdditionalListItem = matchProObj._additional.list.find(reqItem => reqItem._index === pro._index);
          if(matchAdditionalListItem) {
            pro.originInfo = matchAdditionalListItem.originInfo
          }
        }
        // 套餐单价
        if(matchProObj._combo && matchProObj._combo.list && pro.products) {
          let matchComboListItem = matchProObj._combo.list.find(reqItem => reqItem._index === pro._index);
          if(matchComboListItem) {
            pro.originInfo = matchComboListItem.originInfo
          }
        }
      }
    });

  },



}





export default amendProductFee;


// WEBPACK FOOTER //
// ./../../plugins/utils/amendProductFee.js